import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-255131ae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "idea-create-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "step-item"
}, [/*#__PURE__*/_createElementVNode("div", null, "基础信息")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "step-item"
}, [/*#__PURE__*/_createElementVNode("div", null, "首次更新")], -1));
const _hoisted_4 = [_hoisted_2, _hoisted_3];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell-label"
}, "创意类别", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, " *", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cell-label"
}, "项目标题", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, " *", -1));
const _hoisted_10 = {
  class: "cell-box"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-tit"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "cell-label"
}, "轮播图"), /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, " *")], -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-tips"
}, "轮播图建议宽度1080px，宽高比在4:5或5:4之间，最多可上传5张格式jpg、png，不大于 5MB", -1));
const _hoisted_13 = {
  class: "logo_list"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-close"
}, null, -1));
const _hoisted_17 = [_hoisted_16];
const _hoisted_18 = {
  key: 0,
  class: "item upload"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-plus"
}, null, -1));
const _hoisted_20 = {
  class: "cell-box"
};
const _hoisted_21 = {
  class: "cell-box-time"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-tit"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "cell-label"
}, "发布时间")], -1));
const _hoisted_23 = /*#__PURE__*/_createTextVNode("立即发布");
const _hoisted_24 = /*#__PURE__*/_createTextVNode("定时发布");
const _hoisted_25 = {
  class: "cell-tips bottom"
};
const _hoisted_26 = {
  class: "category-content"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  key: 1
};
const _hoisted_29 = {
  key: 0,
  class: "empty"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "首次创意更新", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "使用以下工具将内容添加到您的创意中", -1));
const _hoisted_33 = [_hoisted_30, _hoisted_31, _hoisted_32];
const _hoisted_34 = {
  key: 1,
  class: "imgContent"
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
  key: 1,
  class: "cover"
};
const _hoisted_37 = ["src"];
const _hoisted_38 = {
  key: 2,
  class: "describe"
};
const _hoisted_39 = {
  key: 3,
  class: "video"
};
const _hoisted_40 = ["src"];
const _hoisted_41 = {
  class: "bottom"
};
const _hoisted_42 = {
  class: "normal_op"
};
const _hoisted_43 = ["onClick"];
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-trash"
}, null, -1));
const _hoisted_45 = [_hoisted_44];
const _hoisted_46 = ["onClick"];
const _hoisted_47 = ["onClick"];
const _hoisted_48 = {
  class: "footer"
};
const _hoisted_49 = {
  key: 0,
  class: "btn_field"
};
const _hoisted_50 = {
  key: 1,
  class: "content_btn_field"
};
const _hoisted_51 = {
  class: "count"
};
const _hoisted_52 = {
  class: "op_btn"
};
const _hoisted_53 = {
  class: "btns"
};
const _hoisted_54 = {
  class: "btn img"
};
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" 图片 ");
const _hoisted_56 = ["disabled"];
const _hoisted_57 = {
  class: "btn video"
};
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" 视频 ");
const _hoisted_59 = ["disabled"];
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "编辑文本", -1));
const _hoisted_61 = {
  class: "dialogFooter"
};
const _hoisted_62 = {
  class: "txt_btns"
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "编辑文本", -1));
const _hoisted_64 = {
  class: "dialogFooter"
};
const _hoisted_65 = {
  class: "txt_btns describe"
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "发起者协议", -1));
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cont"
}, [/*#__PURE__*/_createElementVNode("p", null, "1. 我承诺该创意是由我/我的团队原创作品或已取得合法授权。"), /*#__PURE__*/_createElementVNode("p", null, "2. 我承诺该创意如启动销售，将在摩点独家发起众筹。"), /*#__PURE__*/_createElementVNode("p", null, "3. 我承诺授予摩点及其关联方对该项目进行宣传推广的权利。"), /*#__PURE__*/_createElementVNode("p", null, "4. 我承诺该创意及相关产品不违反任何国家法律法规、摩点平台协议及平台规则，对本项目引起的任何纠纷独立承担法律责任。")], -1));
const _hoisted_68 = {
  class: "dialogFooter"
};
const _hoisted_69 = {
  class: "xieyi"
};
const _hoisted_70 = {
  key: 0,
  class: "iconfont icon-select"
};
const _hoisted_71 = {
  key: 1,
  class: "iconfont icon-unselected"
};
const _hoisted_72 = /*#__PURE__*/_createTextVNode("我已阅读并理解完整");
const _hoisted_73 = /*#__PURE__*/_createTextVNode("，同意并接受全部条款。");
const _hoisted_74 = {
  class: "txt_btns"
};
const _hoisted_75 = {
  class: "wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_radio = _resolveComponent("van-radio");
  const _component_van_radio_group = _resolveComponent("van-radio-group");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _component_image_cropper = _resolveComponent("image-cropper");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(['step-box', {
      'content': $data.stepIndex == 1
    }])
  }, _hoisted_4, 2), $data.stepIndex == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_van_cell, {
    "is-link": "",
    onClick: _cache[0] || (_cache[0] = $event => $data.show = true),
    value: $data.categoryName
  }, {
    title: _withCtx(() => [_hoisted_6, _hoisted_7]),
    _: 1
  }, 8, ["value"]), _createVNode(_component_van_field, {
    modelValue: $data.proName,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.proName = $event),
    placeholder: "请输入项目标题（限26个字）",
    "input-align": "right",
    maxlength: "26"
  }, {
    label: _withCtx(() => [_hoisted_8, _hoisted_9]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _hoisted_12, _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fileList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "item"
    }, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_14), _createElementVNode("div", {
      class: "del",
      onClick: _withModifiers($event => $options.del(index), ["stop"])
    }, _hoisted_17, 8, _hoisted_15)]);
  }), 128)), $data.fileList.length < 5 ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_hoisted_19, _createElementVNode("input", {
    type: "file",
    accept: "image/*",
    onChange: _cache[2] || (_cache[2] = $event => $options.uploadImg($event))
  }, null, 32)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createVNode(_component_van_radio_group, {
    modelValue: $data.checked,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.checked = $event),
    direction: "horizontal"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_radio, {
      name: "1",
      "checked-color": "#1A1A1A"
    }, {
      default: _withCtx(() => [_hoisted_23]),
      _: 1
    }), _createVNode(_component_van_radio, {
      name: "0",
      "checked-color": "#1A1A1A"
    }, {
      default: _withCtx(() => [_hoisted_24]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_25, _toDisplayString($data.checked == '1' ? '审核成功后立即发布' : '审核成功后可在“创意管理”中设置发布时间'), 1)]), _createVNode(_component_van_action_sheet, {
    show: $data.show,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $data.show = $event),
    description: "创意类别"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_26, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.categoryList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "category-item",
        key: index,
        onClick: $event => $options.checkCategory(item)
      }, _toDisplayString(item.catename_ch), 9, _hoisted_27);
    }), 128))]), _createElementVNode("div", {
      class: "category-btn",
      onClick: _cache[4] || (_cache[4] = $event => $data.show = false)
    }, "取消")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_image_cropper, {
    visible: $data.cropperVisible,
    url: $data.imgUrl,
    "file-info": $data.fileInfo,
    onCancel: _cache[6] || (_cache[6] = $event => $data.cropperVisible = false),
    onSuccess: $options.cropperSuccess
  }, null, 8, ["visible", "url", "file-info", "onSuccess"])])) : (_openBlock(), _createElementBlock("div", _hoisted_28, [$data.imgContent.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_33)) : (_openBlock(), _createElementBlock("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.imgContent, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['item', {
        'active': $data.editIndex == index
      }, {
        'txt': item.content_type == 1
      }, {
        'describeItem': item.content_type == 2 && item.describe
      }]),
      onClick: _withModifiers($event => $options.focusItem(item, index), ["stop"])
    }, [item.content_type == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(['text', {
        'title': item.is_title == 1
      }])
    }, _toDisplayString(item.content_value), 3)) : _createCommentVNode("", true), item.content_type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("img", {
      src: item.content_value
    }, null, 8, _hoisted_37)])) : _createCommentVNode("", true), item.content_type == 2 && item.describe ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(item.describe), 1)) : _createCommentVNode("", true), item.content_type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("img", {
      src: item.video_cover
    }, null, 8, _hoisted_40)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", {
      class: "del",
      onClick: _withModifiers($event => $options.delItem(index), ["stop"])
    }, _hoisted_45, 8, _hoisted_43)]), item.content_type == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "bottom_op txt",
      onClick: _withModifiers($event => $options.editTxt(item, index), ["stop"])
    }, "编辑文本", 8, _hoisted_46)) : _createCommentVNode("", true), item.content_type == 2 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "bottom_op describe",
      onClick: _withModifiers($event => $options.editDescribe(item, index), ["stop"])
    }, "图片描述", 8, _hoisted_47)) : _createCommentVNode("", true)])], 10, _hoisted_35);
  }), 128))]))])), _createElementVNode("div", _hoisted_48, [$data.stepIndex == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_createElementVNode("div", {
    class: "btn",
    onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => $options.comfirm && $options.comfirm(...args), ["stop"]))
  }, "下一步")])) : (_openBlock(), _createElementBlock("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, _toDisplayString($options.txtAllLength) + "/2000", 1), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", {
    class: "btn txt",
    onClick: _cache[8] || (_cache[8] = _withModifiers($event => $options.appendMixContent(1), ["stop"]))
  }, "文本"), _createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("input", {
    type: "file",
    accept: "image/*",
    onChange: _cache[9] || (_cache[9] = $event => $options.uploadContentImg($event)),
    disabled: $options.picBlockLength >= 10
  }, null, 40, _hoisted_56)]), _createElementVNode("div", _hoisted_57, [_hoisted_58, _createElementVNode("input", {
    type: "file",
    id: "video_file",
    name: "video_file",
    accept: "video/mp4",
    onChange: _cache[10] || (_cache[10] = $event => $options.uploadVideoChange($event)),
    disabled: $options.mediaBlockLength >= 3
  }, null, 40, _hoisted_59)])]), _createElementVNode("div", {
    class: "back",
    onClick: _cache[11] || (_cache[11] = _withModifiers($event => $data.stepIndex = 0, ["stop"]))
  }, "上一步"), _createElementVNode("div", {
    class: _normalizeClass(['publish', {
      'active': $data.imgContent.length > 0
    }]),
    onClick: _cache[12] || (_cache[12] = _withModifiers((...args) => $options.publish && $options.publish(...args), ["stop"]))
  }, "发布", 2)])]))]), _createVNode(_component_van_popup, {
    class: "txtDialog",
    show: $data.txtShow,
    "onUpdate:show": _cache[16] || (_cache[16] = $event => $data.txtShow = $event),
    closeable: "",
    "close-icon": "close",
    position: "bottom",
    style: {
      height: '80%'
    },
    "lock-scroll": false,
    "safe-area-inset-bottom": true
  }, {
    default: _withCtx(() => [_hoisted_60, _createVNode(_component_van_field, {
      class: _normalizeClass({
        'title': $data.is_title == 1
      }),
      modelValue: $data.txtDialogMessage,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.txtDialogMessage = $event),
      rows: "1",
      autosize: "",
      type: "textarea",
      placeholder: "请输入文本",
      disabled: $options.txtAllLength >= 2000
    }, null, 8, ["class", "modelValue", "disabled"]), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", {
      class: _normalizeClass(['change_btn', {
        'text': $data.is_title == 1
      }, {
        'h1': $data.is_title == 0
      }]),
      onClick: _cache[14] || (_cache[14] = _withModifiers((...args) => $options.changeTitle && $options.changeTitle(...args), ["stop"]))
    }, _toDisplayString($data.is_title == 1 ? '转为正文' : '转为标题'), 3), _createElementVNode("div", {
      class: "save_btn",
      onClick: _cache[15] || (_cache[15] = _withModifiers((...args) => $options.txtConfirm && $options.txtConfirm(...args), ["stop"]))
    }, "保存")])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    class: "txtDialog",
    show: $data.describeShow,
    "onUpdate:show": _cache[19] || (_cache[19] = $event => $data.describeShow = $event),
    closeable: "",
    "close-icon": "close",
    position: "bottom",
    style: {
      height: '80%'
    },
    "lock-scroll": false,
    "safe-area-inset-bottom": true
  }, {
    default: _withCtx(() => [_hoisted_63, _createVNode(_component_van_field, {
      modelValue: $data.describeDialogMessage,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.describeDialogMessage = $event),
      rows: "2",
      autosize: "",
      type: "textarea",
      placeholder: "请输入文本",
      maxlength: "50",
      "show-word-limit": ""
    }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", {
      class: "save_btn",
      onClick: _cache[18] || (_cache[18] = _withModifiers((...args) => $options.describeConfirm && $options.describeConfirm(...args), ["stop"]))
    }, "保存")])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    class: "txtDialog",
    show: $data.createIdeaVisible,
    "onUpdate:show": _cache[24] || (_cache[24] = $event => $data.createIdeaVisible = $event),
    closeable: "",
    "close-icon": "close",
    position: "bottom",
    style: {
      height: '80%'
    },
    "lock-scroll": false,
    "safe-area-inset-bottom": true
  }, {
    default: _withCtx(() => [_hoisted_66, _hoisted_67, _createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("div", {
      onClick: _cache[21] || (_cache[21] = _withModifiers($event => $data.xieyiAgree = !$data.xieyiAgree, ["stop"]))
    }, [$data.xieyiAgree ? (_openBlock(), _createElementBlock("i", _hoisted_70)) : (_openBlock(), _createElementBlock("i", _hoisted_71)), _createElementVNode("p", null, [_hoisted_72, _createElementVNode("a", {
      onClick: _cache[20] || (_cache[20] = _withModifiers((...args) => $options.goInitXieyi && $options.goInitXieyi(...args), ["stop"])),
      href: "javascript:void(0)"
    }, "《发布者协议》"), _hoisted_73])])]), _createElementVNode("div", _hoisted_74, [_createElementVNode("div", {
      class: "xieyi_btn",
      onClick: _cache[22] || (_cache[22] = _withModifiers($event => {
        $data.createIdeaVisible = false;
      }, ["stop"]))
    }, "再想想"), _createElementVNode("div", {
      class: "xieyi_btn confirm",
      onClick: _cache[23] || (_cache[23] = _withModifiers((...args) => $options.confirm_publish && $options.confirm_publish(...args), ["stop"]))
    }, "同意并发布")])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $data.loading
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_75, [_createVNode(_component_van_loading, {
      size: "24px",
      color: "#fff",
      vertical: ""
    }, {
      default: _withCtx(() => [_createTextVNode("请求中..." + _toDisplayString($data.progress > 0 ? $data.progress + '%' : ''), 1)]),
      _: 1
    })])]),
    _: 1
  }, 8, ["show"])]);
}